import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { url } from "../base/Variables";
import { LazyAxios, catchError, getToken, handleRequest } from "../base";

const baseUrl = `${url}/api/v1`

const initialState = {
    'cart_loading': false,
    'cart_success': null,
    'cart_error': null,
    'cart_error_type': null,
    'cart_action': null,
    'cart_item': null,
    'cart_total': 0,
    'cart_item_list': {}
}

const getCartAllItem = createAsyncThunk('getCartAllItem', async (_, { rejectWithValue }) => {
    try {
        const token = getToken()
        const axios = await LazyAxios()
        const request = await axios.get(`${baseUrl}/cart/`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        console.log(request.data)
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})

const placeOrder = createAsyncThunk('placeOrder', async (address_id, { rejectWithValue }) => {
    try {
        const token = getToken()
        const axios = await LazyAxios()
        const request = await axios.put(`${baseUrl}/order/placeOrder/`, { 'address_id': address_id }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        console.log(request)
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})


const cartSlice = createSlice({
    name: 'cartSlice',
    initialState: initialState,
    reducers: {
        cartSliceDefault(state, action) {
            state.cart_item = null
            state.cart_item_list = {}
            state.cart_total = 0
            state.cart_loading = false
            state.cart_success = null
            state.cart_error = null
            state.cart_error_type = null
        },
        cartDefault(state, action) {
            state.cart_error = null
            state.cart_error_type = null
            state.cart_success = null
        },
        // set the cart error
        setCartError(state, action) {
            state.cart_error = action.payload.error_message
            state.cart_error_type = 'exception'
        },
        // get the cart total at cart.js
        getCartTotal(state, action) {
            state.cart_total = state.cart_item ? state.cart_item.reduce((total, item) => {
                return total + (item.product_price * item.quantity)
            }, 0) : state.cart_total
        },

        // update the quantity or delete the item in cart 
        updateCart(state, action) {
            if (action.payload.type === 'delete') {
                state.cart_item = state.cart_item ? state.cart_item.filter((item) => {
                    return item.id !== action.payload.id
                }) : state.cart_item
            }
            else {
                state.cart_item = state.cart_item ? state.cart_item.map((item, index) => {
                    if (item.id === action.payload.id) {
                        return action.payload
                    }
                    else {
                        return item
                    }
                }) : state.cart_item
            }
        },
        // delete - remove the product from added list, empty - to clear list, add product id to list
        updateCartItemList(state, action) {
            if (action.payload.type === 'delete') {
                const { [`p${action.payload.id}`]: _, ...newObj } = state.cart_item_list
                state.cart_item_list = newObj
            }
            else if (action.payload.type === 'empty') {
                state.cart_item_list = {}
            }
            else {
                const id = action.payload
                if (!state.cart_item_list[`p${id}`]) {
                    state.cart_item_list = { ...state.cart_item_list, [`p${id}`]: id }
                }
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCartAllItem.pending, (state) => {
                state.cart_loading = true
                state.cart_error = null
                state.cart_error_type = null
                state.cart_success = null
                state.cart_item = null
            })
            .addCase(getCartAllItem.fulfilled, (state, action) => {
                state.cart_loading = false
                state.cart_item = action.payload.data
            })
            .addCase(getCartAllItem.rejected, (state, action) => {
                state.cart_error = action.payload.error_message
                state.cart_error_type = action.payload.type
                state.cart_loading = false
            })

            .addCase(placeOrder.pending, (state) => {
                state.cart_loading = true
                state.cart_error = null
                state.cart_success = null
            })
            .addCase(placeOrder.fulfilled, (state, action) => {
                console.log(action.payload)
                state.cart_loading = false
                state.cart_success = action.payload.success_message
            })
            .addCase(placeOrder.rejected, (state, action) => {
                console.log(action.payload)
                state.cart_loading = false
                state.cart_error = action.payload.error_message
                state.cart_error_type = action.payload.type
            })

    }
})

export default cartSlice;
export { getCartAllItem, placeOrder }
export const { cartSliceDefault, cartDefault, setCartError, updateCart, updateCartItemList, changeCartTotal, getCartTotal } = cartSlice.actions